// extracted by mini-css-extract-plugin
export default {"root":"Serch_root__3ZjbP","input":"Serch_input__scbUo","icon":"Serch_icon__zKzP0","clearIcon":"Serch_clearIcon__+jMjl"};